import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
// import moment from 'moment';
import Countdown from 'react-countdown-now';
import clsx from 'clsx';
import withI18next from '~/../hocs/_withI18next';
// import CountdownTimer from '~/containers/CountdownTimer';
import Config from '~/config';
import { locales } from '~/utils';
import { formatFloatNumber } from '~/utils/formatter';
import {
  makeSelectCountdownDiscount,
  makeSelectDiscountCoupon,
} from '~/containers/PaymentModal/selectors';
import themeVariables from '~/shared/themeVariables';

const ButtonSubscribe = ({ t, onClick, lng }) => {
  let customStyle = {};

  if (lng === 'tw') {
    customStyle = { padding: '10px 30px' };
  }

  return (
    <button
      type="button"
      className="btn-subscribe"
      style={customStyle}
      onClick={onClick}
    >
      {t('subcribe_now')}
    </button>
  );
};

// const YEARLY_PRICES = {
//   USD: 115,
//   TWD: 3600,
//   THB: 3585,
//   CNY: 794,
//   VND: 2675606,
//   KRW: 135649,
// };
// const MONTHLY_PRICES = {
//   USD: 9.58,
//   TWD: 300,
//   THB: 298.75,
//   CNY: 66.16,
//   VND: 222967,
//   KRW: 11304,
// };

// const GroupSites = ({ lng, t }) => {
//   const listDomain = Config.getListDomain(lng);
//   const acWebsites = [
//     {
//       site: 'photo_ac',
//       link: listDomain.PHOTO_AC,
//       logo: `${Config.staticPrefix}/static/assets/image/logo/photoAC_logo_grey.svg`,
//       text_logo: t('free_stock_photos_ac'),
//     },
//     {
//       site: 'illust_ac',
//       link: listDomain.ILLUST_AC,
//       logo: `${Config.staticPrefix}/static/assets/image/logo/illustAC_logo_grey.svg`,
//       text_logo: t('free_vector_clip_art'),
//     },
//     {
//       site: 'silhouette_ac',
//       link: listDomain.SILHOUETTE_AC,
//       logo: `${Config.staticPrefix}/static/assets/image/logo/silhouetteAC_logo_grey.svg`,
//       text_logo: t('free_vector_silhouettes'),
//     },
//     {
//       site: 'design_ac',
//       link: listDomain.DESIGN_AC,
//       logo: `${Config.staticPrefix}/static/assets/image/logo/templateAC_logo_grey.svg`,
//       text_logo: t('free_design_templates'),
//     },
//   ];
//   return (
//     <div>
//       <div className="group-websites-plan-box-title">
//         <span>{t('premium_apply_group_sites')}</span>
//       </div>
//       <div className="dashed-line" />
//       <div className="group-websites-plan-box">
//         {acWebsites.map((item) => (
//           <a
//             key={item.site}
//             href={item.link}
//             target="_blank"
//             className={`website-item ${item.site}`}
//             rel="noreferrer"
//           >
//             <img
//               className={`website-logo ${item.site}`}
//               src={item.logo}
//               alt={item.text_logo}
//             />
//           </a>
//         ))}
//       </div>
//     </div>
//   );
// };

const renderCountdown = (
  { hours, minutes, seconds, milliseconds, days },
  t,
  discount,
  type,
) => {
  if (type === 'FIRST_TIME') {
    return (
      <div>
        <span
          dangerouslySetInnerHTML={{
            __html: t('price_discount_during', {
              discount,
            }),
          }}
        />
        <span
          className="time"
          dangerouslySetInnerHTML={{
            __html: t(
              days > 0
                ? 'countdown_time_day_hour_minute_second_milli'
                : 'countdown_time_hour_minute_second_milli',
              {
                days,
                hours,
                minutes,
                seconds,
                // millis: `${parseInt(milliseconds / 10)}`.padStart(2, '0'),
              },
            ),
          }}
        />
      </div>
    );
  }
  if (type === 'SECOND_TIME') {
    return (
      <div>
        <span>{t('price_increases_after')}</span>
        <span
          className="time"
          dangerouslySetInnerHTML={{
            __html: t('countdown_time_day_hour_minute_second_milli', {
              days,
              hours,
              minutes,
              seconds,
              millis: `${parseInt(milliseconds / 10)}`.padStart(2, '0'),
            }),
          }}
        />
      </div>
    );
  }
};

const renderFirstTimeCountdownTimer = (
  futureTime,
  t,
  discount,
  updateCountdown,
) => (
  <div style={{ marginTop: 7 }}>
    <Countdown
      date={Date.now() + futureTime}
      renderer={({ hours, minutes, seconds, milliseconds, days }) =>
        renderCountdown(
          {
            hours,
            minutes,
            seconds,
            milliseconds,
            days,
          },
          t,
          discount,
          'FIRST_TIME',
        )
      }
      // onTick={({ total }) => updateCountdown(total)
      // }
      onComplete={() => updateCountdown(0)}
      intervalDelay={10}
      precision={2}
    />
    <div
      style={{
        fontStyle: 'italic',
        marginTop: 10,
      }}
    >
      {t('discount_description')}
    </div>
  </div>
);

const renderSecondTimeCountDownTimer = (futureTime, t) => (
  <div style={{ marginTop: 7 }}>
    <Countdown
      date={Date.now() + futureTime}
      renderer={({ hours, minutes, seconds, milliseconds, days }) =>
        renderCountdown(
          {
            hours,
            minutes,
            seconds,
            milliseconds,
            days,
          },
          t,
          null,
          'SECOND_TIME',
        )
      }
      // onTick={({ total }) => updateCountdown(total)
      // }
      // onComplete={this.handleCompleteCountdown}
      intervalDelay={10}
      precision={2}
    />
  </div>
);

const displayPriceOnCampaign = (originPrice, countdown, discount, t, lng) => {
  // const currentDate = new Date().getDate();
  // const currentDate = 26;
  // const firstTime = {
  //   startDate: 1,
  //   endDate: 25,
  // };
  // const secondTime = {
  //   startDate: 26,
  //   endDate: 30,
  // };
  if (
    countdown &&
    countdown.typeCountdown == 'FIRST_TIME' &&
    countdown.isActive
  ) {
    let discountedMonthlyPrice =
      (originPrice.monthlyPrice * (100 - discount)) / 100;
    let discountedYearlyPrice =
      (originPrice.yearlyPrice * (100 - discount)) / 100;

    discountedMonthlyPrice = formatFloatNumber(
      locales.roundPriceByCurrency(
        originPrice.currencyName,
        discountedMonthlyPrice,
      ),
    );

    discountedYearlyPrice = formatFloatNumber(
      locales.roundPriceByCurrency(
        originPrice.currencyName,
        discountedYearlyPrice,
      ),
    );

    // console.log("--- discountedMonthlyPrice", discountedMonthlyPrice, "--- discountedYearlyPrice", discountedYearlyPrice);
    return (
      <>
        <strike className="info" style={{ fontSize: '1.2em' }}>
          <b>{`${originPrice.currencyIcon}${formatFloatNumber(
            locales.roundPriceByCurrency(
              originPrice.currencyName,
              originPrice.yearlyPrice,
            ),
          )} ${originPrice.currencyName}`}</b>
          <small>/{t('year')}</small>
        </strike>
        <span className={`price ${Config.getPrefixContent('price-color')}`}>
          <b>
            {' '}
            {`${lng === 'tw' ? 'NT' : ''}${
              originPrice.currencyIcon
            }${discountedYearlyPrice} ${originPrice.currencyName}`}
          </b>
          <small>/{t('year')}</small>
        </span>
      </>
    );
  }

  return (
    <span className="price">
      {`${lng === 'tw' ? 'NT' : ''}${originPrice.currencyIcon}${
        originPrice.currencyName === 'USD'
          ? Number(originPrice.monthlyPrice).toFixed(2)
          : formatFloatNumber(
              locales.roundPriceByCurrency(
                originPrice.currencyName,
                originPrice.monthlyPrice,
              ),
            )
      }`}
      {/* <small>/{t('year')}</small> */}
      {/* {t('every_year')} */}
    </span>
  );
};

const displayCountdownTimer = (countdown, t, coupon, updateCountdown, plan) => {
  if (plan === 'YEARLY') {
    if (
      countdown &&
      countdown.typeCountdown == 'FIRST_TIME' &&
      countdown.isActive
    ) {
      return renderFirstTimeCountdownTimer(
        countdown.remainingDurationInMilliseconds,
        t,
        coupon.percent_off,
        updateCountdown,
      );
    }

    if (
      countdown &&
      countdown.typeCountdown == 'FIRST_TIME' &&
      !countdown.isActive
    ) {
      return '';
    }

    if (
      countdown &&
      countdown.typeCountdown == 'SECOND_TIME' &&
      countdown.isActive
    ) {
      // const futureTime = '2020-12-01T00:00:00';
      return renderSecondTimeCountDownTimer(
        countdown.remainingDurationInMilliseconds,
        t,
      );
    }
  }

  if (
    plan === 'MONTHLY' &&
    countdown &&
    countdown.typeCountdown == 'SECOND_TIME' &&
    countdown.isActive
  ) {
    // const futureTime = '2020-12-01T00:00:00';
    return renderSecondTimeCountDownTimer(
      countdown.remainingDurationInMilliseconds,
      t,
    );
  }

  return '';
};

const YearlyBoxContent = ({
  t,
  onSubscribe,
  // nextDateMonthlyPrice,
  yearlyPrice,
  // nextDateYearlyPrice,
  monthlyPrice,
  currencyIcon,
  currencyName,
  lng,
  countdown,
  updateCountdown,
  coupon,
}) => {
  return (
    <div className="plan-box">
      <div className="plan-price">
        <div className="box-header">
          {/* {onSubscribe && (
            <span className={`badge ${Config.getPrefixContent('badge')}`}>
              {t('best_plan')}
            </span>
          )} */}
          <span className="title">{t('register_premium_price_title5')}</span>
          {displayCountdownTimer(
            countdown,
            t,
            coupon,
            updateCountdown,
            'YEARLY',
          )}
        </div>
        <div
          className={clsx('box-content', {
            'box-premium-subscribe': !onSubscribe,
          })}
        >
          <div className="box-content-price">
            {displayPriceOnCampaign(
              {
                yearlyPrice,
                monthlyPrice,
                currencyIcon,
                currencyName,
              },
              countdown,
              coupon && coupon.percent_off,
              t,
              lng,
            )}
            <span className="price-save">
              {lng === 'tw' ? t('save-price') : t('Save')} 10%
            </span>
          </div>
          {onSubscribe && (
            <ButtonSubscribe t={t} onClick={onSubscribe} lng={lng} />
          )}
        </div>
      </div>
      <span className="box-footer">
        {t('register_premium_card_number_content10', {
          money: `${lng === 'tw' ? 'NT' : ''}${currencyIcon}${yearlyPrice}`,
        })}
      </span>
      {/* {onSubscribe && <GroupSites t={t} lng={lng} />} */}
    </div>
  );
};

const MonthlyBoxContent = ({
  t,
  onSubscribe,
  monthlyPrice,
  currencyIcon,
  currencyName,
  lng,
  countdown,
}) => {
  return (
    <div className="plan-box monthly-box">
      <div className="plan-price">
        <div className="box-header">
          <span className="title">{t('register_premium_price_title1')}</span>
          {displayCountdownTimer(countdown, t, null, null, 'MONTHLY')}
        </div>
        <div
          className={clsx('box-content', {
            'box-premium-subscribe': !onSubscribe,
          })}
        >
          <div className="box-content-price">
            <span className="price">
              {`${lng === 'tw' ? 'NT' : ''}${currencyIcon}${
                currencyName === 'USD'
                  ? Number(monthlyPrice).toFixed(2)
                  : formatFloatNumber(
                      locales.roundPriceByCurrency(currencyName, monthlyPrice),
                    )
              } `}
            </span>
          </div>
          {onSubscribe && (
            <ButtonSubscribe t={t} onClick={onSubscribe} lng={lng} />
          )}
        </div>
      </div>
      <span className="box-footer">
        {t('subscription_automatically_renewed_monthly', {
          money: `${currencyIcon}${monthlyPrice}`,
        })}
      </span>
    </div>
  );
};

const PremiumPlanBox = withI18next()((props) => {
  const {
    currentPlan,
    nextDatePlan,
    typePlan,
    t,
    onRegisterPremium,
    displayAtPaymentModal = false,
    isMonthLyAtDesign,
    lng,
    updateCountdown,
    countdown,
    coupon,
  } = props;

  // const monthlyPrice = formatFloatNumber(
  //   locales.roundPriceByCurrency(
  //     currentPlan.currency,
  //     currentPlan.monthlyConversion,
  //   ),
  // );
  // const mainPrice = formatFloatNumber(
  //   locales.roundPriceByCurrency(currentPlan.currency, currentPlan.price),
  // );
  let handler = () => onRegisterPremium(typePlan);
  if (displayAtPaymentModal) handler = null;

  let nextDateMonthlyPrice;
  let nextDateMainPrice;
  if (nextDatePlan) {
    nextDateMonthlyPrice = formatFloatNumber(
      locales.roundPriceByCurrency(
        nextDatePlan.currency,
        nextDatePlan.monthlyConversion,
      ),
    );
    nextDateMainPrice = formatFloatNumber(
      locales.roundPriceByCurrency(nextDatePlan.currency, nextDatePlan.price),
    );
  }
  return (
    <>
      <div
        className="premium-plan-box"
        style={
          displayAtPaymentModal
            ? {
                textAlign: 'center',
              }
            : isMonthLyAtDesign
            ? {
                padding: '31px 0px',
              }
            : null
        }
        onClick={handler}
      >
        {typePlan === 'ONE_YEAR' && (
          <YearlyBoxContent
            t={t}
            lng={lng}
            monthlyPrice={currentPlan.monthlyConversion}
            yearlyPrice={currentPlan.price}
            nextDateMonthlyPrice={nextDateMonthlyPrice}
            nextDateYearlyPrice={nextDateMainPrice}
            currencyIcon={currentPlan.currencyIcon}
            currencyName={currentPlan.currency}
            onSubscribe={handler}
            countdown={countdown}
            updateCountdown={updateCountdown}
            coupon={coupon}
          />
        )}
        {typePlan === 'MONTHLY' && (
          <MonthlyBoxContent
            t={t}
            lng={lng}
            monthlyPrice={currentPlan.price}
            nextDateMonthlyPrice={nextDateMonthlyPrice}
            currencyIcon={currentPlan.currencyIcon}
            currencyName={currentPlan.currency}
            onSubscribe={handler}
            countdown={countdown}
          />
        )}
      </div>
      <style jsx global>
        {`
          .premium-plan-box:hover {
            // border: 1px solid #9bafbf;
            cursor: pointer;
          }

          .btn-subscribe {
            padding: 10px 24px;
            height: 48px;
            background: ${themeVariables.colors.primary};
            border-radius: ${Config.isIllustAC() ? '40px' : '4px'};
            font-size: 16px;
            line-height: 28px;
            color: #ffffff;
            font-weight: 700;
            border: none;
          }

          .btn-subscribe:hover {
            opacity: 0.8;
          }

          .premium-plan-box {
            border-radius: 4px;
            background: #fff;
            border: 1px solid #e3e3e3;
            box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.08);
            overflow: hidden;
          }

          .premium-plan-box:nth-child(2) {
            margin-top: 24px;
          }

          .premium-plan-box .plan-box {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            border-top: 8px solid ${themeVariables.colors.primary};
            padding: 32px 16px;
          }

          .premium-plan-box .monthly-box {
            border-top: none;
          }

          .plan-box .box-header span {
            font-weight: 600;
            font-size: 20px;
            line-height: 23px;
            color: #000000;
          }

          .box-content-price {
            display: flex;
            align-items: center;
          }

          .plan-box .box-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 16px 0;
          }

          .box-content.box-premium-subscribe {
            justify-content: center;
          }

          .box-content .price {
            font-weight: 600;
            font-size: 36px;
            line-height: 42px;
            color: #000000;
          }

          .box-content .price-save {
            background: #3ad7c3;
            border-radius: 40px;
            padding: 10px;
            text-align: center;
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            color: #ffffff;
            text-transform: uppercase;
            margin-left: 8px;
          }

          .box-footer {
            font-style: italic;
            font-weight: 400;
            font-size: 16px;
            line-height: 28px;
            color: #000000;
          }

          @media (max-width: ${themeVariables.breakpoints.tabletS.minWidth}px) {
            .plan-box .box-content {
              flex-direction: column;
            }

            .box-content-price {
              margin-bottom: 10px;
            }

            .premium-plan-box .plan-box {
              padding: 16px 8px;
              justify-content: center;
              align-items: center;
            }
          }

          // .premium-plan-box .plan-box .plan-price {
          //   display: flex;
          //   flex-direction: row;
          //   justify-content: flex-start;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left {
          //   width: 100%;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .register-hint {
          //   font-style: italic;
          //   font-size: 12px;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .badge {
          //   position: relative;
          //   display: inline-block;
          //   min-width: 50%;
          //   height: 24px;
          //   padding: 0 0 0 1.5em;
          //   border: none;
          //   border-radius: 0;
          //   font-size: 0.875em;
          //   font-weight: 400;
          //   line-height: 24px;
          //   text-align: left;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .ill_badge {
          //   background: #d73a4e;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .sil_badge {
          //   background: #41b9b8;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .photo_badge {
          //   background: #4c9ade;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .design_badge {
          //   background: #ffa823;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .badge:after {
          //   position: absolute;
          //   top: 50%;
          //   right: -12px;
          //   transform: translateY(-50%) rotate(45deg);
          //   width: 24px;
          //   height: 24px;
          //   background: #fff;
          //   content: '';
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .content {
          //   display: flex;
          //   flex-direction: column;
          //   justify-content: flex-start;
          //   padding: 0.5em 0px 1.5em 1.5em;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .content .title {
          //   font-size: 1em;
          //   font-weight: 700;
          //   text-transform: uppercase;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .content .price {
          //   margin-top: 14px;
          //   font-size: 2em;
          // }
          // .premium-plan-box
          //   .plan-box
          //   .plan-price
          //   .box-left
          //   .content
          //   .photo_price-color {
          //   color: #4c9ade;
          // }
          // .premium-plan-box
          //   .plan-box
          //   .plan-price
          //   .box-left
          //   .content
          //   .ill_price-color {
          //   color: #d73a4e;
          // }
          // .premium-plan-box
          //   .plan-box
          //   .plan-price
          //   .box-left
          //   .content
          //   .sil_price-color {
          //   color: #41b9b8;
          // }
          // .premium-plan-box
          //   .plan-box
          //   .plan-price
          //   .box-left
          //   .content
          //   .design_price-color {
          //   color: #ffa823;
          // }
          // .premium-plan-box .plan-box .plan-price .box-left .content .info {
          //   margin-top: 14px;
          // }
          // .premium-plan-box
          //   .plan-box
          //   .plan-price
          //   .box-left
          //   .content
          //   .discounted-price {
          //   margin-top: 0px;
          // }
          // .premium-plan-box
          //   .plan-box
          //   .plan-price
          //   .box-left
          //   .content
          //   .original-price {
          //   text-decoration: line-through;
          //   font-weight: normal;
          //   color: #3e3e3f;
          // }
          // .premium-plan-box
          //   .plan-box
          //   .plan-price
          //   .box-left
          //   .content
          //   .original-price
          //   b {
          //   font-weight: normal;
          // }
          // .premium-plan-box .plan-box .plan-price .box-right {
          //   padding-right: 1.5em;
          //   padding-top: 100px;
          //   display: flex;
          //   flex-direction: row;
          //   justify-content: flex-end;
          //   align-items: flex-end;
          // }
          // .premium-plan-box .plan-box .plan-price .box-right .btn-subcribe {
          //   padding: 10px;
          // }
          // .premium-plan-box .plan-box .plan-benefit {
          //   padding: 0.5em 1.5em;
          // }
          // .premium-plan-box .plan-box .plan-benefit .dashed-line {
          //   border: dashed 0.5px #3e3e3f;
          //   margin: 0.5em 0em;
          // }
          // .group-websites-plan-box {
          //   display: flex;
          //   flex-direction: row;
          //   justify-content: space-between;
          //   align-items: flex-start;
          //   margin-top: 16px;
          // }

          // .website-item {
          //   width: 18%;
          //   cursor: pointer;
          // }

          // .website-item.design_ac,
          // .website-item.silhouette_ac {
          //   width: 24%;
          //   cursor: pointer;
          // }

          // .premium-plan-box
          //   .plan-box
          //   .plan-benefit
          //   .group-websites-plan-box
          //   .website-logo {
          //   width: 100%;
          // }
        `}
      </style>
    </>
  );
});

const mapStateToProps = createStructuredSelector({
  countdown: makeSelectCountdownDiscount(),
  coupon: makeSelectDiscountCoupon(),
});
export default connect(mapStateToProps)(PremiumPlanBox);
